import { Building2, History, LifeBuoy, ReceiptIndianRupee, ShieldCheck } from "lucide-react";
import { defineFeature } from "../types";

/**
 * The Lean2Automate console — the tier above every workspace.
 *
 * Deliberately NOT in the sidebar. The navigation is derived from workspace
 * permissions, and platform access is a different grant entirely: an agency
 * owner holds `org:manage` and must still never see this. So it is reachable
 * by URL and through the command palette (whose console commands appear only
 * once `/api/platform/v1/me` has said yes), and the page itself asks the same
 * before rendering anything — a customer who guesses the URL gets a flat "this
 * is not yours to open".
 *
 * Putting the gate in the page rather than the nav is the safe direction: a
 * missing nav entry hides a feature, while a missing page check exposes one.
 */
export default defineFeature({
  key: "platform",
  title: "Platform",
  routes: [{ path: "platform", lazy: () => import("./page") }],
  commands: [
    {
      key: "platform.console",
      label: "Lean2Automate platform console",
      icon: Building2,
      to: "/platform",
      group: "navigate",
      audience: "platform",
      keywords: ["platform", "workspaces", "tenants", "licences", "seats", "lean2automate", "admin"],
    },
    {
      key: "platform.invoices",
      label: "Platform licence invoices",
      icon: ReceiptIndianRupee,
      to: "/platform?tab=invoices",
      group: "navigate",
      audience: "platform",
      keywords: ["licence invoices", "billing workspace", "who owes", "overdue licences"],
    },
    {
      key: "platform.support",
      label: "Platform support queue",
      icon: LifeBuoy,
      to: "/platform?tab=support",
      group: "navigate",
      audience: "platform",
      keywords: ["tickets", "queue", "customers"],
    },
    {
      key: "platform.history",
      label: "Platform history",
      icon: History,
      to: "/platform?tab=history",
      group: "navigate",
      audience: "platform",
      keywords: ["platform audit", "console trail", "who changed the licence"],
    },
    {
      key: "platform.access",
      label: "Platform access",
      icon: ShieldCheck,
      to: "/platform?tab=admins",
      group: "navigate",
      audience: "platform",
      keywords: ["platform admins", "grant", "revoke"],
    },
  ],
});
